<h4 mat-dialog-title xmlns="http://www.w3.org/1999/html">{{'general.adresse' |translate }}</h4>
<mat-dialog-content>
  <app-geocoder [cedex]="true"  [adresse]="adresse" (place)="changeAdresse($event)"></app-geocoder>
  @if (!adresseIsValid()) {
    <div class="invalid-feedback display-block">
      <p>* {{ 'front.coordonnesJS.attentionAdresseSauvegardeeSiComplete' | translate }}.</p>
    </div>
  }
</mat-dialog-content>



<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="null">{{ 'general.annuler' | translate }}</button>
  <button mat-raised-button color="primary" [disabled]="!adresseIsValid()" (click)="submit()">{{ 'general.valider' | translate }}</button>
</mat-dialog-actions>
